import { Mutations } from 'vuex-smart-module';
import VueRouter, { RouteConfig } from 'vue-router';
import WebSiteState from './state';
import Menu from '@/models/Menu';
import Identity from '@/models/Identity';

import Article from '@/views/Article.vue';
import ArticleContent from '@/views/ArticleContent.vue';

function addSlash(link: string): string {
  if (link.startsWith('/')) {
    return link;
  } else {
    return '/' + link;
  }
}
function removeSlash(link: string): string {
  if (link.startsWith('/')) {
    return link.substr(1, link.length - 1);
  }
  return link;
}

export default class WebSiteMutations extends Mutations<WebSiteState> {
    logout():void {
        this.state.Identity = new Identity();
    }
    login(data: Identity): void {
        this.state.Identity = new Identity(data);
        if (this.state.Identity.Roles && this.state.Identity.Roles.length > 0) {
            const admin = this.state.Identity.Roles.some((row) => {
                return row === 'Admin';
            });
            const cm = this.state.Identity.Roles.some((row) => {
                return row === 'ContentManager';
            });
            this.state.CanAdd = admin || cm;
            this.state.CanEdit = admin || cm;
            this.state.CanDelete = admin || cm;
        } else {
            this.state.CanAdd = false;
            this.state.CanEdit = false;
            this.state.CanDelete = false;
        }
    }
    setReturnUrl(data: string): void {
        this.state.ReturnUrl = data;
    }
    setMenuItems(data: Menu[]): void {
        const nest = (items: Menu[], id: number | null = null): Menu[] =>  items
        .filter(item => item.ParentId === id)
        .map(item => ({ ...item, SubMenu: nest(items, item.Id) }));

        this.state.PlainMenuItems = data;
        this.state.MenuItems = nest(data);
        //console.log(nest(data));       
    }
    setRouter(router: VueRouter) {
        // Загруженное меню
          const menuItems = this.state.MenuItems;
        
          if (menuItems && menuItems.length > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              // Меню верхнего уровня
              const topMenu = menuItems[i];
        
              // Ссылка на меню верхнего уровня
              const topMenuLink = addSlash(topMenu.Link);
        
              // Если есть дочерние меню
              if (topMenu.SubMenu.length > 0) {
                // Конфигурация маршрута
                const config: RouteConfig = {
                  path: topMenuLink,
                  component: Article,
                  meta: { origin: topMenuLink, id: topMenu.Id },
                  children: []
                };
                // console.log('(x) route Article to [' + topMenuLink + '] with meta origin=' + topMenuLink + ', id=' + topMenu.Id);
                // Обработка вложенных маршрутов
                if (topMenu.SubMenu && topMenu.SubMenu.length > 0) {
                  for (let j = 0; j < topMenu.SubMenu.length; j++) {
                    // Меню дочернего уровня
                    const subMenu = topMenu.SubMenu[j];
        
                    // Ссылка на меню дочернего уровня
                    const subMenuLink = removeSlash(subMenu.Link);
        
                    // Конфигурация маршрута
                    const subRoute: RouteConfig = {
                      path: subMenuLink,
                      meta: { origin: topMenuLink, id: subMenu.Id, articleId: subMenu.Id },
                      components: {
                        articleContent: ArticleContent
                      }
                    };
        
                    // добавляем в маршрут
                    config.children?.push(subRoute);
        
                    // console.log('(s) subroute ArticleContent to [' + subMenuLink + '] with meta origin=' + topMenuLink + ', id=' + topMenu.Id+', articleId='+subMenu.Id);
        
                    // Обработка вложенных маршрутов
                    if (subMenu.SubMenu && subMenu.SubMenu.length > 0) {
                      for (let k = 0; k < subMenu.SubMenu.length; k++) {
                        // Меню дочернего уровня
                        const subSubMenu = subMenu.SubMenu[k];
        
                        // Ссылка на меню дочернего уровня
                        const subSubMenuLink = removeSlash(subSubMenu.Link);
        
                        const subSubRoute: RouteConfig = {
                          path: subMenuLink + '/' + subSubMenuLink,
                          meta: { origin: topMenuLink, id: subMenu.Id, articleId: subSubMenu.Id },
                          components: {
                            articleContent: ArticleContent
                          }
                        };
        
                        // добавляем в маршрут
                        config.children?.push(subSubRoute);
        
                        // console.log('(ss) subroute ArticleContent to [' + subMenuLink + '/' + subSubMenuLink + '] with meta origin=' + topMenuLink + ', id=' + topMenu.Id+', articleId='+subSubMenu.Id);
                      }
                    }
                  }
                }
                router.addRoute(config);
              } else {
                // Конфигурация маршрута
                const config: RouteConfig = {
                  path: topMenuLink,
                  component: ArticleContent,
                  meta: { origin: topMenuLink, id: topMenu.Id, articleId: topMenu.Id },
                  children: []
                };
                router.addRoute(config);
                // console.log('(1) route Article to [' + topMenuLink + '] with meta origin=' + topMenuLink + ', id=' + topMenu.Id);
              }
            }
          }
    }
    setArticleId(id: number): void {
        this.state.ArticleId = id;
    }
    setSubject(subject: string): void {
        this.state.Subject = subject;
    }
    setHtml(html: string): void {
        this.state.Html = html;
    }
    setVisible(visible: boolean): void {
        this.state.Visible = visible;
    }
    setContinue(c: boolean): void {
        this.state.Continue = c;
    }
    setFiles(files: File[]): void {
        this.state.Files = files;
    }
    setLoading(c: boolean): void {
        this.state.Loading = c;
    }
    setInitializing(c: boolean): void {
        this.state.Initializing = c;
    }
    setError(error: any):void {
        //console.log(error);
        //console.log(error.data);
        if (typeof error == 'object') {
            // Если http ошибка
            if (error.response?.data) {
                this.state.Error = error.response?.data;
            } else if (error.message) {
                this.state.Error = error.message;
            } else {
                this.state.Error = error;
            }
        } else {
            this.state.Error = error;
        }
        this.state.Dialog = true;
    }    
    setDialog(dialog: boolean):void {
        this.state.Dialog = dialog;
    }
    appendFile(file: File): void {
        this.state.Files.push(file);
    }
    deleteFile(index: number): void {
        this.state.Files.splice(index, 1);
    }
}